import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.23301 17.0323C3.8277 17.0323 2.68848 15.8931 2.68848 14.4878V9.39869C2.68848 6.20002 2.68848 4.60068 3.68218 3.60698C4.67588 2.61328 6.27521 2.61328 9.47389 2.61328H12.8666C14.2719 2.61328 15.4111 3.75251 15.4111 5.15781"
        stroke="#F59C53"
        strokeWidth="1.27226"
      />
      <path
        d="M5.23291 10.2468C5.23291 7.84777 5.23291 6.64827 5.97819 5.90299C6.72346 5.15771 7.92296 5.15771 10.322 5.15771H12.8665C15.2655 5.15771 16.465 5.15771 17.2103 5.90299C17.9556 6.64827 17.9556 7.84777 17.9556 10.2468V14.4877C17.9556 16.8867 17.9556 18.0862 17.2103 18.8314C16.465 19.5767 15.2655 19.5767 12.8665 19.5767H10.322C7.92296 19.5767 6.72346 19.5767 5.97819 18.8314C5.23291 18.0862 5.23291 16.8867 5.23291 14.4877V10.2468Z"
        stroke="white"
        strokeWidth="1.27226"
      />
    </svg>
  );
};

export default Icon;
